<template>
  <div class="container-fluid h-100">
    <div class="content-profile-user" id="contentProfileUser" alt="Imagen de fondo de perfil">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-12 col-md-7 col-lg-6 col-xl-6">
          <div
            class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end justify-content-xl-end "
          >
            <div class="col-12 col-md-12 col-lg-10 col-xl-10">
              <h1 class="title-profile-1 th-title-r">PERFIL</h1>
            </div>

            <div
              class="col-12 col-md-12 col-lg-10 col-xl-10"
              style="text-align: initial; margin: 0px;"
            >
              <p style="font-family:'GothamBookItalic', sans-serif;">
                Porque tú eres lo más importante para el club. Disfruta de los
                beneficios que tenemos para ti
              </p>
              <p
                style="color: #FDCD00; font-size: 23px; text-align: initial; font-family:'GothamBookItalic', sans-serif;"
              >
                <strong>¡Te los mereces!</strong>
              </p>
            </div>
            <!-- <div class="col-12 col-md-12 col-lg-8 col-xl-8">
           
            </div> -->
          </div>
          <template v-if="loading.profile">
            <div
              class="spinner-border text-light"
              style="width: 5rem; height: 5rem;"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </template>
          <template v-else>
            <div class="row pt-3 justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2 padding-sm2">
                <img
                  class="icon-img-svg-name"
                  src="../../assets/img/Recurso 7.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-8 col-xl-8"
                style="text-align: left"
              >
                <label class="label-title label-title-sm th-title-r"
                  ><strong>Nombre: </strong></label
                ><br />
                <label class="  label-title-sm th-title-r">
                  {{ dataUser.name }} {{ dataUser.last_name }}</label
                >
              </div>
            </div>
            <div class="row pt-xl-3 pt-lg-3 pt-md-3 justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img
                  class="icon-img-svg"
                  src="../../assets/img/Recurso 9.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-7 col-xl-7"
                style="text-align: left"
              >
                <label class="label-title text-profile th-title-r"
                  ><strong>Documento: </strong></label
                ><br />
                <label class="th-title-r text-profile">
                  {{ documentUser }} {{ dataUser.document_number }}</label
                >
              </div>
            </div>
            <!-- <div class="row justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img alt="Placa" class="icon-img-svg" src="../../assets/icon/Placa.png" />
              </div>
              <div
                class="col-9 col-md-8 col-lg-7 col-xl-7"
                style="text-align: left"
              >
                <label class="th-title-r label-title text-profile "
                  ><b> Placa</b> </label
                ><br />
                <label class="th-title-r text-profile">
                  {{ dataUser.plate }}</label
                >
              </div>
            </div> -->
            <div class="row justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2 p-phone">
                <img
                  class="icon-img-svg-phone"
                  src="../../assets/img/Recurso 10.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-7 col-xl-7"
                style="text-align: left"
              >
                <label class="th-title-r label-title text-profile "
                  ><strong>Celular: </strong> </label
                ><br />
                <label class="th-title-r text-profile">{{
                  dataUser.phone
                }}</label>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img
                  class="icon-img-svg"
                  src="../../assets/img/Recurso 12.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-7 col-xl-7"
                style="text-align: left"
              >
                <label class="th-title-r label-title text-profile "
                  ><strong>Correo:</strong> </label
                ><br />
                <label class="th-title-r text-profile">
                  {{ dataUser.email }}</label
                >
              </div>
            </div>
            <div class="row justify-content-end">
              <div
                class="col-9 col-md-8 col-lg-7 col-xl-7"
                style="text-align: left"
              >
                <a
                  class=""
                  style="color: #dc3545; cursor: pointer;"
                  data-toggle="modal"
                  data-target="#exampleModalPassword"
                  ><strong>Cambiar contraseña</strong></a
                >
              </div>
            </div>

            <div class="row justify-content-end">
              <div
                class="mt-2 col-12 col-md-12 col-lg-10 col-xl-10"
                style="text-align: left"
              >
                <label class="label-title text-profile" style="color:white"
                  ><strong>ZONA O DISTRIBUIDOR MÁSTER</strong> </label
                ><br />
                <label class="text-profile">{{ infoDistributor }}</label>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="mt-2 col-12 col-md-12 col-lg-8 col-xl-8" style="margin:auto auto auto auto;">
                <!-- <h5>
                  <span
                    @click="openHistory()"
                    class="badge  badge-primary float-left btn-history-s"
                    >Revisa el historial de tus tapas</span
                  >
                </h5> -->
                <h5>
                  <span
                    style="width:100%; height:25px"
                    @click="openShopping()"
                    class="mt-3 badge badge-danger float-left btn-history"
                    >Revisa el historial de tus compras</span
                  >
                </h5>
                <h5>
                  <span
                    style="width:100%; height:25px"
                    @click="openAccount()"
                    class="mt-3 badge badge-primary float-left btn-history-s"
                    >Revisa tu estado de cuenta
                  </span>
                </h5>
                <h5 v-if="dataUser.role_id == 4 || dataUser.role_id == 5">
                  <span
                    style="width:100%; height:25px"
                    @click="openLicense()"
                    class="mt-3 badge badge-danger float-left btn-history"
                    >Ver mi carnet del MotoClub
                  </span>
                </h5>
              </div>
            </div>
            <!-- <div class="row mt-3 justify-content-center">
              <div class="mtPass col-12 col-md-12 col-lg-8 col-xl-" style="text-align: left">
                <button class="btn btn-danger btn-sm btn-block" data-toggle="modal" data-target="#exampleModalPassword"
                  aria-hidden="true">Cambiar contraseña</button>
                <button class="btn btn-danger btn-sm btn-block" @click="openRanking()"
                  aria-hidden="true">Ranking</button>
              </div>
            </div> -->
          </template>
        </div>

        <div class="col-12 col-md-7 col-lg-6 col-xl-6">
          <div
            class="row padding-sm-code justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center"
          >
            <div class="col-12 col-md-12 col-lg-7 col-xl-7">
              <div class="title-profile th-title-r">
                <label style="color:white">
                  <strong>Tus puntos para redimir</strong>
                </label>
              </div>
              <div class="points">
                <div
                  v-if="loading.profile"
                  class="spinner-border text-light"
                  style="width: 5rem; height: 5rem;"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
                <h1 v-else class="text-points">{{ points }}</h1>
              </div>
              <div class="expired_points">
                <h2 class="title_expired_points">Puntos a vencer este mes</h2>
                <h3 class="cant_expired_points">{{ expired_points }}</h3>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-7 col-xl-7">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.code1 }"
                    v-model="code1"
                    type="text"
                    placeholder="Ingresa tus códigos nuevos aquí"
                    class="form-control input-code"
                  />
                </div>
                <span v-if="errors.code1" class="text-danger float-left small error-danger">
                  <strong>{{ errors.code1 }}</strong>
                </span>
                <!-- <p class="info-promo-l">
                  Ingresa aquí si tienes un código promocional
                </p>
                <div class="input-group mb-2">
                  <input
                    id="i-p-code"
                    placeholder="Códgio promocional"
                    v-model="codePromotional"
                    type="text"
                    autocomplete="i-p-code"
                    class="form-control input-code"
                  />
                </div> -->
              </div>
              <button
                :disabled="disableLoading"
                @click="addCode()"
                type="button"
                class="btn btn-danger btn-md btn-block button-send-code mb-3"
              >
                <span
                  v-if="disableLoading"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <strong v-else>Enviar</strong>
              </button>
            </div>

            <div class="col-10">
              <div class="row">
                <!-- <div class="col-12 col-md-6 col-lg-6 col-xl-6 zy">
                  <button
                    class="btn btn-block btn-transparent"
                    :class="{ active: classRankingZ }"
                    @click="openRanking(1)"
                  >
                    RANKING POR ZONA
                  </button>
                </div> -->
                <!-- <div
                  class="col-12 col-md-6 col-lg-6 col-xl-6 pr-sm-0 pr-lg-0 pr-xl-2 pr-md-0 pr-0 pl-0"
                >
                  <button
                    class="btn btn-block btn-transparent"
                    :class="{ active: classRanking }"
                    @click="openRanking(2)"
                  >
                    RANKING GLOBAL
                  </button>
                </div> -->

                <!--<div
                  class="col-12 col-md-6 col-lg-4 col-xl-4 pl-sm-0 pl-lg-0 pl-xl-2 pl-md-0 pl-0 pr-0"
                >
                  <button
                    class="btn btn-block btn-transparent pt-xl-3 pb-xl-3"
                    :class="{ active: classCaps }"
                    @click="openRanking(0)"
                  >
                    TAPAS
                  </button>
                </div>-->
                <div class="col-12 col-md-6 col-lg-6 col-xl-6 zy">
                  <button
                    class="btn btn-block btn-transparent"
                    :class="{ active: classRankingZ }"
                    @click="openRanking(1)"
                  >
                    RANKING POR ZONA
                  </button>
                </div>
                <div
                  class="col-12 col-md-6 col-lg-6s col-xl-6 pr-sm-0 pr-lg-0 pr-xl-2 pr-md-0 pr-0 pl-0"
                >
                  <button
                    class="btn btn-block btn-transparent"
                    :class="{ active: classRanking }"
                    @click="openRanking(2)"
                  >
                    RANKING GLOBAL
                  </button>
                </div>
              </div>
            </div>
            <template>
              <div
                class="col-12 col-md-10 col-lg-10 col-xl-9"
                style="background-color: rgba(89, 89, 89, 0.45)"
              >
                <label class="title-caps mt-3">
                  <strong>¡Tú puedes estar aquí!</strong>
                </label>
                <label v-if="rankinForZone" class="title-ranking">
                  Estos son los 10 primeros lubricadores de tu zona.
                </label>
                <label v-if="!rankinForZone" class="title-ranking">
                  Estos son los 10 primeros lubricadores del ranking global.
                </label>
                <!-- <label class="title-ranking"
                  >Reúne tapas y sube posiciones para ganar.</label
                >-->
                <h4 v-if="rankinForZone">
                  <span class="badge badge-danger" style="font-size: 15px;">{{
                    infoDistributor
                  }}</span>
                </h4>
                <div class="table-responsive">
                  <table
                    class="mt-2 table table-light table-sm table-h table-lubricator table-striped "
                  >
                  <caption class="visually-hidden">Listado de Lubricadores</caption>
                    <thead>
                      <tr class="tr-table-h">
                        <th class="th-title-r" scope="col">#</th>
                        <th class="th-title-r" scope="col">
                          Nombre del lubricador
                        </th>
                        <th class="th-title-r" scope="col">Puntos</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="tr-table-h" v-for="item in listRanking" :key="item.id">
                        <th class="td-lubricator" scope="col">
                          {{ item.num }}
                        </th>
                        <td class="td-lubricator ">
                          {{ item.name }} {{ item.last_name }}
                        </td>
                        <td class="td-lubricator">
                          {{ item.points }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div style="background-color: #ffffff24; border-radius: 10px;">
                  <p>
                    <strong>TOTAL: {{ totalLubricator }} LUBRICADORES</strong>
                  </p>
                </div>
              </div>
            </template>
            <!--  <template v-else>
              <div
                class="col-12 col-md-10 col-lg-10 col-xl-9"
                style="background-color: rgba(89, 89, 89, 0.45)"
              >
               <div class="row justify-content-center">
                  <div class="mt-2 col-12 col-md-12 col-lg-12 col-xl-12">
                    <label class="title-caps"
                      ><b>Tus tapas que te harán ganar</b></label
                    >
                  </div>
                  <div class="col-12 col-md-12 col-lg-9 col-xl-9">
                    <div class="points">
                      <div
                        v-if="loading.profile"
                        class="spinner-border text-light"
                        style="width: 5rem; height: 5rem;"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                      <h1 v-else class="text-points">{{ caps }}</h1>
                    </div>

                    <img
                      width="100"
                      class="img-caps"
                      src="./../../assets/icon/tapas.png"
                    />
                    <div class="info-caps">
                      <label style="color: #FDCD00; font-size: 14px"
                        ><b>
                          Entre más tapas reúnas más oportunidades tienes para
                          ganarte la moto de tus sueños con Havoline 4T
                        </b>
                      </label>
                    </div>
                  </div>
                  <div
                    class="mb-2 col-12 col-md-12 col-lg-10 col-xl-10"
                    style="line-height: 1;padding-left: 34px;"
                  >
                    <small>*Válido del 12 de abril al 30 de junio.</small>
                  </div>
                </div>
              </div>
              
              <div class="mb-3 mt-3 col-12 col-md-12 col-lg-6 col-xl-6">
                <div class="form-group">
                  <div class="input-group mb-3">
                    <input
                      :class="{ 'is-danger': errors.code1 }"
                      v-model="code1"
                      type="number"
                      placeholder="Ingresa aquí la cantidad de tapas"
                      class="form-control input-code"
                    />
                  </div>
                  <span
                    v-if="errors.code1"
                    class="text-danger float-left small error-danger mb-2"
                    >{{ errors.code1 }}</span
                  >
                </div>
                <button
                  :disabled="disableLoading"
                  @click="addCaps()"
                  type="button"
                  class="btn btn-danger btn-md btn-block button-send-code mb-3"
                >
                  <span
                    v-if="disableLoading"
                    class="spinner-border spinner-border-md"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <b v-else>Enviar</b>
                </button>
              </div> 
            </template>-->
          </div>
        </div>
      </div>
    </div>

    <template v-if="history">
      <div class="content-history" id="content-history-id">
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <div class="row justify-content-between">
              <div class="col-10 col-md-10 col-lg-8 col-xl-7 col-sm-10">
                <h1 class="subtitle-h mt-2 mb-4">
                  Historial de tapas redimidas.
                </h1>
              </div>
              <div class="col-1 col-md-1 col-lg-1 col-xl-1 col-sm-1">
                <h1
                  style="text-align: right; cursor: pointer;"
                  class="subtitle-h mt-2"
                  @click="history = false"
                >
                  <i class="fa fa-times text-danger" aria-hidden="true"></i>
                </h1>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <template v-if="alert.status">
              <div class="alert alert-primary " role="alert">
                {{ alert.message }}
              </div>
            </template>
            <div v-else class="table-responsive">
              <table class="table table-light  table-h">
                <caption class="visually-hidden">Listado de Tapas</caption>
                <thead>
                  <tr class="tr-table-h">
                    <!-- <th class="th-title" scope="col">#</th> -->
                    <th class="th-title" scope="col">Cantidad de tapas</th>
                    <th class="th-title" scope="col">Fecha de solicitud</th>
                    <th class="th-title" scope="col">Fecha de aprobación</th>
                    <th class="th-title" scope="col">Estado de la solicitud</th>
                    <th class="th-title" scope="col">Comentario</th>
                    <th class="th-title" scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tr-table-h" v-for="item in listHistory" :key="item.id">
                    <th scope="row">{{ item.amount }}</th>
                    <td>{{ item.created_at }}</td>
                    <td>{{ item.dateCommercial }}</td>
                    <td>{{ item.statu.name }}</td>
                    <td style="text-align: left;">{{ item.comments }}</td>
                    <td>
                      <template v-if="item.status_id == 7">
                        <i
                          data-toggle="modal"
                          data-target="#exampleModal-edit"
                          style="cursor: pointer;"
                          class="fa fa-pencil fa-lg text-danger"
                          @click="dataInfo(item)"
                          aria-hidden="true"
                        ></i>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Historial -->
    <template v-if="shopping">
      <div class="content-history" id="content-history-id">
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-12 col-md-10 col-lg-10 col-xl-10 col-sm-12">
            <div class="row justify-content-between">
              <div class="col-10 col-md-10 col-lg-9 col-xl-8 col-sm-10">
                <h1 class="subtitle-h mt-2 mb-4">Historial de compras</h1>
              </div>
              <div class="col-1 col-md-1 col-lg-1 col-xl-1 col-sm-1">
                <h1
                  style="text-align: right; cursor: pointer;"
                  class="subtitle-h mt-2"
                  @click="shopping = false"
                >
                  <i class="fa fa-times text-danger" aria-hidden="true"></i>
                </h1>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 col-lg-10 col-xl-10 col-sm-12">
            <template v-if="alert.status">
              <div class="alert alert-primary " role="alert">
                {{ alert.message }}
              </div>
            </template>
            <div v-else class="table-responsive">
              <div class="row">
                <div v-for="item in listShopping" :key="item.id">
                  <div class="col-12 col-md-12 mb-3 col-xl-6 col-lg-12">
                    <div class="card card-history-s">
                      <div class="row">
                        <div class="col-12 col-md-4 col-xl-4 mt-4">
                          <img
                            class="rounded-circle"
                            width="140px"
                            height="140px"
                            :src="item.img"
                            alt="..."
                          />
                        </div>
                        <div class="col-12 col-md-8 col-xl-8 col-md-8">
                          <div class="card-body">
                            <p
                              style="color: #1da5df; text-align: initial; margin: 5px"
                            >
                              <strong>{{ item.name }}</strong>
                            </p>
                            <p
                              style="color: #dc3545; text-align: initial; margin: 5px"
                            >
                              <small class="text-muted"
                                >Compra el {{ item.created_at }}</small
                              >
                            </p>
                            <p
                              style="color: #dc3545; text-align: initial; margin: 5px"
                            >
                              <small class="text-muted"
                                >{{ item.points }} puntos</small
                              >
                            </p>

                            <p
                              v-if="item.statusDes == 'Rechazado'"
                              style="color: #fff; text-align: initial; margin: 5px"
                            >
                              <span class="badge bg-danger"
                                >{{ item.statusDes }}
                              </span>
                            </p>

                            <p
                              v-else
                              style="color: #fff; text-align: initial; margin: 5px"
                            >
                              <span class="badge bg-info"
                                >{{ item.statusDes }}
                              </span>
                            </p>

                            <button
                              @click="openModalDetails(item)"
                              class="btn btn-block btn-outline-danger"
                            >
                              <template v-if="loading.btn">
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span class="visually-hidden">Loading...</span>
                              </template>
                              <template v-else>
                                VER DETALLES
                              </template>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Carnet del Lubricador -->
    <template v-if="dataUser.role_id == 4 || dataUser.role_id == 5">
      <template v-if="showLicense">

        <div class="row justify-content-center">
          <div id="content_title_carnet">
            <h1 style="text-align:center !important;" class="title_carnet">Tú carnet del MotoClub</h1>
            <div>
              <h1
                style="text-align:center; cursor:pointer;"
                class="title_carnet"
                @click="showLicense = false"
              >
                <i class="fa fa-times text-danger" aria-hidden="true"></i>
              </h1>
            </div>
          </div>
        </div>

        <template>
          <div id="content_carnet">
            <div id="user_data_carnet">
              <div class="data_carnet">
                <span class="name_and_last_name">
                  <strong style="color:white; text-align:initial;">
                    {{ dataUser.name }} {{ dataUser.last_name }}
                  </strong>
                </span>
                <span class="cc_and_document">
                  <span style="display:inline-flex; color:white; text-align:initial;">
                    {{ dataUser.document_type.name }}: {{ dataUser.document_number }}
                  </span>
                </span>
                <span class="user_role">
                  <strong style="color:white;">Tipo de usuario:&nbsp;</strong>
                  <span style="color:white; text-align: initial;">
                    {{ dataUser.role_id == 4 ? 'Lubricador' : dataUser.role_id == 5 ? 'Motero' : '' }}
                  </span>
                </span>
                <span class="user_plate" v-if="dataUser.role_id == 4">
                  <strong style="color:white;">Distribuidor:&nbsp;</strong>
                  <span style="color:white; text-align: initial;">
                    {{ nameDistributor }}
                  </span>
                </span>
                <span class="user_city">
                  <strong style="color:white;">Ciudad:&nbsp;</strong>
                  <span style="color:white; text-align: initial;">
                    {{ dataUser.city.name }}
                  </span>
                </span>
                <div class="user_activo">
                  <strong class="miembro_activo">{{ dataUser.status.description.toUpperCase() }}</strong><br>
                  <span class="havoline_motoclub">HAVOLINE MOTOCLUB</span>
                </div>
                <hr class="red_line"><br>

                <div class="qr_code">
                  <qr-code 
                    :text="urlUserAlliance + dataUser.id"
                    :size="140"
                  ></qr-code>
                </div>
                <div class="info_adicional">
                  <span style="color:white; font-size:12px;">
                    Este carnet es personal e intransferible y no podrá ser usado sin autorización del titular del ID.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button
            @click="downloadPDF()"
            class="btn btn-block btn-outline-danger"
            id="btn_download_carnet"
          >
            <template v-if="loading.btn">
              <span class="visually-hidden">Descargando...</span>&nbsp;
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true">
              </span>
            </template>
            <template v-else>
              Descargar
            </template>
          </button>
        </template>
      </template>
    </template>

    <template v-if="loading.list">
      <div
        class="spinner-border text-danger"
        style="width: 3rem; height: 3rem;"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </template>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal-edit"
      tabindex="-1"
      aria-labelledby="exampleModal-editLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title lubricator-title-modal"
              id="exampleModal-editLabel"
            >
              <strong>Editar solicitud</strong>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" style="text-align: left">
              <label style="color: #595959">
                Fecha de solicitud: {{ info.created_at }} </label
              ><br />
              <label style="color: #595959">
                Cantidad de tapas actual: {{ info.amount }} </label
              ><br />
              <label style="color: #595959">
                Descripción del rechazo de la solicitud:
                {{ info.comments }} </label
              ><br />
              <span style="color: #595959">Cantidad de tapas</span>
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.amount }"
                    type="number"
                    v-model="amount"
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                  />
                </div>
                <span
                  v-if="errors.amount"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.amount }}</span
                >
              </div>
            </div>
          </div>
          <div class="modal-footer" style="justify-content: center">
            <button type="button" @click="editar()" class="btn btn-danger">
              <template v-if="loading.btn">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span class="sr-only">Cargando...</span>
              </template>
              <template v-else>
                Editar
              </template>
            </button>
            <button
              type="button"
              class="btn "
              style="background-color: #AAA; color: #fff;"
              data-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalles-->
    <div class="modal" id="loadingModal" tabindex="-1">
      <div
        class="spinner-border text-danger loading-modal"
        style="width: 6rem; height: 6rem;"
        role="status"
      ></div>
    </div>

    <div
      class="modal fade"
      id="exampleModalDetailsM"
      tabindex="-1"
      aria-labelledby="exampleModalDetailsMLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="mt-2"
              id="exampleModalDetailsMLabel"
              style="color:#dc3545; min-width:100%;"
            >
              <strong>Detalles de la compra</strong>
            </h5>
            <button
              id="close_detail_product"
              type="button"
              class="close pt-4"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-4">
            <div class="row ">
              <div class="col-12 col-md-4 col-xl-4 col-md-4 mt-0">
                <img
                  class="rounded-circle"
                  width="140px"
                  height="140px"
                  :src="purchaseData.img"
                  alt="..."
                />
              </div>
              <div class="col-12 col-md-8 col-xl-8 col-md-8">
                <div class="card-body">
                  <p style="color: #1da5df; text-align: initial; margin: 1px">
                    <strong>{{ purchaseData.name }}</strong>
                  </p>
                  <p style="color: #dc3545; text-align: initial; margin: 1px">
                    <small class="text-muted"
                      >Compra el {{ purchaseData.created_at }}</small
                    >
                  </p>

                  <p style="color: #dc3545; text-align: initial; margin: 1px">
                    <small class="text-muted"
                      >{{ purchaseData.points }} puntos</small
                    >
                  </p>
                </div>
              </div>
              <div class="col-12">
                <p style="color: #dc3545; text-align: initial; margin: 1px">
                  <small class="text-muted">{{
                    purchaseData.description
                  }}</small>
                </p>

                <template v-if="purchaseData.product_type_id == 6">
                  <template v-if="loading.descriptionAll">
                    <div
                      class="spinner-border text-danger"
                      style="width: 5rem; height: 5rem;"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="purchaseData.bonus_id != null">
                      <p class="text-left text-dark fs-5 font-weight-bold mt-3">
                        INFORMACIÓN DEL BONO
                      </p>

                      <div v-if="purchaseData.showBtn">
                        <button
                          @click="downloadBonus(purchaseData)"
                          class="btn btn-danger"
                        >
                          DESCARGAR
                        </button>
                      </div>
                      <div v-else>
                        <h1>
                          <span class="badge badge-danger">
                            {{ purchaseData.bonus_id }}
                          </span>
                        </h1>
                      </div>
                    </template>
                    <p
                      style="color: #6e767e; text-align: initial; margin-top: 5px pt-4"
                    >
                      Detalle de redención:
                    </p>
                    <p
                      style="color: #6e767e; text-align: initial; margin-top: 5px pt-4"
                    >
                      {{ purchaseData.descrip }}
                    </p>
                  </template>
                </template>

                <template v-if="purchaseData.product_type_id == 4">
                  <!-- <p style="color: #dc3545; text-align: initial; margin: 1px">
                    <small class="text-muted">Fecha de compra {{ purchaseData.created_at }}</small>
                  </p> -->
                  <p style="color: #dc3545; text-align: initial; margin: 1px">
                    <small class="text-muted"
                      >Fecha de activación:
                      {{ purchaseData.day_of_activation }}</small
                    >
                  </p>
                  <p style="color: #dc3545; text-align: initial; margin: 1px">
                    <small class="text-muted"
                      >Fecha de expiración:
                      {{ purchaseData.expiration_date }}</small
                    >
                  </p>
                  <p style="color: #dc3545; text-align: initial; margin: 1px">
                    <small class="text-muted"
                      >Precio: ${{ purchaseData.price }}</small
                    >
                  </p>
                </template>

                <hr />
                <template v-if="purchaseData.product_type_id == 4">
                  <p
                    style="color: #1da5df; text-align: center; font-size: 30px; margin-bottom: 0rem;"
                  >
                    <strong>{{ purchaseData.code }}</strong>
                  </p>
                  <barcode :value="purchaseData.code" displayValue="false">
                    Error al cargar el código de barras.
                  </barcode>

                  <!-- <div class="container" style="margin-top:30px;">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="hovereffect">
                          <img class="img-responsive" :src="purchaseData.products.img" alt="" />
                          <div class="overlay">
                            <p>
                              <button @click="downloadVoucher()" class="btn btn-danger btn-sm">
                                <b>DESCARGAR BONO</b>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </template>
              </div>
            </div>
            <!-- </div> -->
          </div>
          <!-- <div class="modal-footer" style="justify-content: center">
            <button type="button" class="btn btn-lg" style="background-color: #AAA; color: #fff;" data-dismiss="modal">
              Cancelar
            </button>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Modal Cambio password-->
    <div
      class="modal fade"
      id="exampleModalPassword"
      tabindex="-1"
      aria-labelledby="exampleModalPasswordLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalPasswordLabel"
              style="color: #595959"
            >
              <strong>Cambiar contraseña</strong>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  placeholder="Escribe aquí la contraseña actual"
                  :class="{ 'is-danger': errors.currentPassword }"
                  type="password"
                  ref="current_password"
                  v-model="form.currentPassword"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                />
                <div @click="showPass(1)" class="eye_pass">
                  <span id="pass1" class="fa-regular fa-eye-slash"></span>
                </div>
              </div>
              <div style="text-align: right">
                <span
                  v-if="errors.currentPassword"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.currentPassword }}</span
                >
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  placeholder="Escribe aquí la nueva contraseña"
                  :class="{ 'is-danger': errors.pass }"
                  type="password"
                  ref="password"
                  v-model="form.pass"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                />
                <div @click="showPass(2)" class="eye_pass">
                  <span id="pass2" class="fa-regular fa-eye-slash"></span>
                </div>
              </div>
              <div style="text-align: right">
                <span
                  v-if="errors.pass"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.pass }}</span
                >
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  placeholder="Escribe aquí la confirmación de la contraseña"
                  :class="{ 'is-danger': errors.pass_confirmation }"
                  type="password"
                  ref="confirm_password"
                  v-model="form.pass_confirmation"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                />
                <div @click="showPass(3)" class="eye_pass">
                  <span id="pass3" class="fa-regular fa-eye-slash"></span>
                </div>
              </div>
              <div style="text-align: right">
                <span
                  v-if="errors.pass_confirmation"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.pass_confirmation }}</span
                >
              </div>
            </div>
          </div>
          <div class="modal-footer" style="justify-content: center">
            <button
              type="button"
              class="btn "
              style="background-color: #AAA; color: #fff;"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="changePassword()"
            >
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ESTADO DE CUENTA -->
    <div
      class="modal fade"
      id="account-state"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l" style="border-radius: 50px;">
          <div class="modal-body img-account">
            <!-- <div class="boton">
              <button
                type="button"
                class="close close-info-l"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div> -->
            <div class="row justify-content-center">
              <div class="div-account">
                <h4 class="text-danger mb-0">
                  <span><strong>ESTADO DE CUENTA</strong></span>
                </h4>
              </div>

              <div
                class="col-12 col-sm-8 col-md-9 col-lg-8 col-xl-8 mb-0 mb-xl-5 mb-lg-5 mt-0 mt-xl-5 mt-lg-5"
              >
                <div class="row mt-4 ">
                  <div class="col-12 col-sm-2 col-md-12 col-lg-2 col-xl-2">
                    <p style="text-align: initial;" class="mt-2">
                      <span><strong>DESDE:</strong></span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.monthFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">MES</option>
                        <option
                          :key="data.num"
                          v-for="data in monthFrom"
                          :value="data.num"
                        >
                          {{ data.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.dayFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">DÍA</option>
                        <option
                          :key="data"
                          v-for="data in dayFrom"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.yearFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">AÑO</option>
                        <option
                          :key="data"
                          v-for="data in yearFrom"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12 col-sm-2 col-md-12 col-lg-2 col-xl-2 ">
                    <p style="text-align: initial;" class="mt-2">
                      <span><strong>HASTA:</strong></span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.monthUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">MES</option>
                        <option
                          :key="data.num"
                          v-for="data in monthUntil"
                          :value="data.num"
                        >
                          {{ data.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.dayUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">DÍA</option>
                        <option
                          :key="data"
                          v-for="data in dayUntil"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.yearUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">AÑO</option>
                        <option
                          :key="data"
                          v-for="data in yearUntil"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <button @click="getAccount()" class="btn btn-get-black">
                  <template v-if="loading.listA">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Buscar
                  </template>
                </button>
              </div>

              <!-- <div class="col-12 mt-2 mb-4">
                <button @click="downloadAccount()" class="btn btn-down-yellow">
                  <template v-if="loading.btn">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Descargar
                  </template>
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ESTADO DE CUENTA TABLA -->
    <div
      class="modal fade"
      id="account-state-get"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l" style="border-radius: 50px;">
          <div class="modal-body img-account">
            <!-- <div class="boton">
              <button
                type="button"
                class="close close-info-l"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div> -->
            <div class="row justify-content-center">
              <div class="div-account">
                <h4 class="text-danger mb-0">
                  <span><strong>ESTADO DE CUENTA</strong></span>
                </h4>
              </div>
            </div>

            <div class="row justify-content-center mt-5">
              <div class="col-11 table-account">
                <template v-if="loading.listA">
                  <div class="pr-5 pt-5" style="text-align: center">
                    <div
                      class="spinner-border text-danger"
                      style="width: 5rem; height: 5rem;"
                      role="status"
                    ></div>
                  </div>
                </template>

                <div v-else class="table-responsive">
                  <table class="table table-sm table-account-t">
                    <caption class="visually-hidden">Historial</caption>
                    <thead>
                      <tr>
                        <th class="th-account-1" scope="col">Fecha</th>
                        <th class="th-account" scope="col">
                          Ingreso de códigos
                        </th>
                        <th class="th-account-1" scope="col">
                          Egreso redenciones
                        </th>
                        <th class="th-account" scope="col">Detalle</th>
                        <th class="th-account-1" scope="col">
                          Estado redenciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in listAccount" :key="data.id">
                        <td scope="row">{{ data.date }}</td>
                        <td>{{ data.total_codes }}</td>
                        <td>{{ data.total_redeems }}</td>
                        <td>{{ data.detail }}</td>
                        <td>{{ data.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-12 mt-5 mb-4">
                <!-- <button @click="downloadAccount()" class="btn btn-down-yellow">
                  <template v-if="loading.btn">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Descargar
                  </template>
                </button> -->
                <button @click="closeModal()" class="btn btn-down-yellow">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal actualización de datos -->
    <div
      class="modal fade"
      id="exampleModalUpdate"
      tabindex="-1"
      aria-labelledby="exampleModalUpdateLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalUpdateLabel"
              style="color: #595959"
            >
              <strong>Actualizar datos</strong>
            </h5>
            <button
              type="button"
              class="close close_update"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Tipo de documento *</small
                  ><br>
                  <div class="input-group mb-3 ">
                    <select
                      v-model="dataUser.document_type_id"
                      class="form-control"
                      :class="{ 'is-danger': errorUpdate.document_type_id }"
                      id="exampleFormControlSelect1"
                      placeholder="Tipo de documento *"
                      disabled
                    >
                      <option value="0" disabled selected
                        >Tipo de documento *</option
                      >
                      <option
                        v-for="(item, i) in listTypeDocuments"
                        :key="'td' + i"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errorUpdate.document_type_id"
                    class="text-danger float-left small error-danger"
                    >{{ errorUpdate.document_type_id }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Número de documento *</small
                  ><br>
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tu número de documento"
                      :class="{ 'is-danger': errorUpdate.document_number }"
                      type="text"
                      v-model="dataUser.document_number"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      disabled
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errorUpdate.document_number"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.document_number }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Nombres *</small><br>
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tus nombres"
                      :class="{ 'is-danger': errorUpdate.name }"
                      type="text"
                      v-model="dataUser.name"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errorUpdate.name"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.name }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Apellidos *</small><br>
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tus apellidos"
                      :class="{ 'is-danger': errorUpdate.last_name }"
                      type="text"
                      v-model="dataUser.last_name"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errorUpdate.last_name"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.last_name }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Departamento *</small><br>

                  <div class="input-group mb-3">
                    <select
                      v-model="dataUser.state_id"
                      class="form-control"
                      :class="{ 'is-danger': errorUpdate.state_id }"
                      id="exampleFormControlSelect1"
                    >
                      <option disabled value="0" selected>Departamento</option>
                      <option
                        v-for="(item, i) in listStates"
                        :value="item.id"
                        :key="'st' + i"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errorUpdate.state_id"
                    class="text-danger float-left small error-danger"
                    >{{ errorUpdate.state_id }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959">Ciudad *</small><br>

                  <div class="input-group mb-3">
                    <select
                      v-model="dataUser.city_id"
                      class="form-control"
                      :class="{ 'is-danger': errorUpdate.city_id }"
                      id="exampleFormControlSelect1"
                    >
                      <option value="0" disabled selected>Ciudad *</option>
                      <option
                        v-for="(item, i) in listCities"
                        :key="'ci' + i"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errorUpdate.city_id"
                    class="text-danger float-left small error-danger"
                    >{{ errorUpdate.city_id }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959">Dirección *</small><br>
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí la dirección *"
                      :class="{ 'is-danger': errorUpdate.address }"
                      type="text"
                      v-model="dataUser.address"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errorUpdate.address"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.address }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Teléfono *</small><br>
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tu teléfono"
                      :class="{ 'is-danger': errorUpdate.phone }"
                      type="text"
                      v-model="dataUser.phone"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errorUpdate.phone"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.phone }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959">Género</small><br>
                  <div class="input-group mb-3">
                    <select
                      v-model="dataUser.gender_id"
                      class="form-control"
                      :class="{ 'is-danger': errorUpdate.gender_id }"
                      id="exampleFormControlSelect1"
                      placeholder="Ingresa aquí el género"
                    >
                      <option value="4" disabled selected
                        >Ingresa aquí el género *</option
                      >
                      <option
                        v-for="(item, i) in listGenders"
                        :key="'td' + i"
                        :value="item.id"
                        class="color-option"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <!-- <div style="text-align: right">
                    <span
                      v-if="errorUpdate.gender_id"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.gender_id }}</span
                    >
                  </div> -->
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959">Email *</small><br>
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tu correo"
                      :class="{ 'is-danger': errorUpdate.email }"
                      type="text"
                      v-model="dataUser.email"
                      class="form-control"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errorUpdate.email"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.email }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959">Fecha de nacimiento *</small><br>
                  <div class="input-group mb-3">
                    <input
                      :class="{ 'is-danger': errorUpdate.birthdate }"
                      type="text"
                      v-model="dataUser.birthdate"
                      class="form-control"
                      placeholder="fecha de nacimiento *"
                      :min="minDate()"
                      :max="maxDate()"
                      onfocus="(this.type='date')"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errorUpdate.birthdate"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errorUpdate.birthdate }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="justify-content: center">
            <button
              type="button"
              class="btn btn_cancel"
              style="background-color:#AAA; color:#fff;"
              data-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              :disabled="disableLoadingSend"
              type="button"
              @click="updateData()"
              class="btn btn-danger"
              id="btn-register-id"
            >
              <span
                v-if="disableLoadingSend"
                class="spinner-border spinner-border-md"
                role="status"
                aria-hidden="true"
              ></span>
              <template v-else>Actualizar</template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from "jquery";
import VueBarcode from "vue-barcode";
import { DATE } from "../../config/utils.js";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  components: {
    barcode: VueBarcode,
    qrCode: VueQRCodeComponent,
  },
  data() {
    return {
      infoAccount: {
        monthFrom: null,
        dayFrom: null,
        yearFrom: null,
        monthUntil: null,
        dayUntil: null,
        yearUntil: null,
      },
      listAccount: [],
      monthFrom: DATE.month,
      dayFrom: DATE.day,
      yearFrom: DATE.year,
      monthUntil: DATE.month,
      dayUntil: DATE.day,
      yearUntil: DATE.year,

      codePromotional: null,
      purchaseData: {
        // products: {
        //   name: "",
        //   img: "",
        //   points: 0,
        //   description: ""
        // }
      },
      totalLubricator: 0,
      listRanking: [],
      classCaps: true, // solo este tiene que estar activo
      classRanking: false,
      classRankingZ: true,
      ranking: false, // este falso
      caps: 0,
      amount: 0,
      info: {
        created_at: "",
        amount: 0,
      },
      loading: {
        list: false,
        btn: false,
        btnCaps: false,
        profile: false,
        listA: false,
        descriptionAll: false,
      },
      alert: {
        status: true,
        message: "",
      },
      shopping: false,
      history: false,
      showLicense: false,
      listHistory: [],
      listShopping: [],
      dataUser: [],
      listTypeDocuments: [],
      listStates: [],
      listCities: [],
      listGenders: [],
      documentUser: "",
      cityUser: "",
      redeemCodes: 0,
      points: "*",
      code1: null,
      infoDistributor: "",
      disableLoading: false,
      disableLoadingSend: false,
      form: {
        pass: "",
        pass_confirmation: "",
        currentPassword: "",
      },
      errors: {
        amount: false,
        code1: false,
        pass: false,
        pass_confirmation: false,
        currentPassword: false,
      },
      errorUpdate: {
        name: false,
        last_name: false,
        state_id: false,
        city_id: false,
        address: false,
        phone: false,
        // gender_id: false,
        email: false,
        birthdate: false,
      },
      urlUserAlliance: 'https://havolinemotoclub.com/consulta/alianza/usuario/',
      nameDistributor: "",
      rankinForZone: true,
      expired_points: "*",
      ip_address: "8.8.8.8"
    };
  },
  watch: {
    amount: function(n) {
      if (!n) {
        this.errors.amount = "El número de tapas es requerido";
      } else if (this.isNumeric(n) && n < 0) {
        this.errors.amount = "El número de tapas no puede ser negativo";
      } else {
        this.errors.amount = false;
      }
    },
    code1: function(n) {
      if (!n) {
        this.errors.code1 = "El código es requerido.";
      } else {
        this.errors.code1 = false;
      }
    },
    "form.pass": function(n) {
      if (!n) {
        this.errors.pass = "La contraseña es requerida.";
      } else if (!this.validPassword(n)) {
        this.errors.pass =
          "La contraseña es inválida, debe tener entre 8 a 16 carácteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.";
      } else {
        this.errors.pass = false;
      }
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    },
    "form.pass_confirmation": function() {
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    },

    // Validar actualización de datos
    "dataUser.name": function() {
      if (this.dataUser.name == "") {
        this.errorUpdate.name = "El nombre es obligatorio";
      } else {
        this.errorUpdate.name = "";
      }
    },
    "dataUser.last_name": function() {
      if (this.dataUser.last_name == "") {
        this.errorUpdate.last_name = "El apellido es obligatorio";
      } else {
        this.errorUpdate.last_name = "";
      }
    },
    "dataUser.state_id": function(n) {
      if (n) {
        this.getCities(n);
      }
      if (this.dataUser.state_id == "") {
        this.errorUpdate.state_id = "El departamento es obligatorio";
      } else {
        this.errorUpdate.state_id = "";
      }
    },
    "dataUser.city_id": function() {
      if (this.dataUser.city_id == "") {
        this.errorUpdate.city_id = "La ciudad es obligatoria";
      } else {
        this.errorUpdate.city_id = "";
      }
    },
    "dataUser.address": function() {
      if (this.dataUser.address == "") {
        this.errorUpdate.address = "La dirección es obligatoria";
      } else {
        this.errorUpdate.address = "";
      }
    },
    "dataUser.phone": function() {
      if (this.dataUser.phone == "") {
        this.errorUpdate.phone = "El número de contacto es obligatorio";
      } else {
        this.errorUpdate.phone = "";
      }
    },
    // "dataUser.gender_id": function() {
    //   if (this.dataUser.gender_id == 4) {
    //     this.errorUpdate.gender_id = "El genero es obligatorio";
    //   } else {
    //     this.errorUpdate.gender_id = "";
    //   }
    // },
    "dataUser.email": function() {
      if (this.dataUser.email == "") {
        this.errorUpdate.email = "El email es obligatorio";
      } else {
        this.errorUpdate.email = "";
      }
    },
    "dataUser.birthdate": function() {
      if (this.dataUser.birthdate == "") {
        this.errorUpdate.birthdate = "La fecha de nacimiento es obligatoria";
      } else {
        this.errorUpdate.birthdate = "";
      }
    },
  },
  methods: {
    minDate() {
      const now = new Date();
      now.setFullYear(now.getFullYear() - 100);
      return now.toISOString().substr(0, 10);
    },
    maxDate(){
      const now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      return now.toISOString().substr(0, 10);
    },
    openAccount() {
      $("#account-state").modal("show");
    },
    downloadBonus(data) {
      var link = document.createElement("a");
      link.setAttribute("href", data.bonus_id);
      link.setAttribute("target", "_blank");
      link.setAttribute("download", "Bono.pdf");
      document.body.appendChild(link);
      link.click();
    },
    getAccount() {
      if (
        this.infoAccount.monthFrom == null &&
        this.infoAccount.yearFrom == null &&
        this.infoAccount.dayFrom == null &&
        this.infoAccount.yearUntil == null &&
        this.infoAccount.monthUntil == null &&
        this.infoAccount.dayUntilFrom == null
      ) {
        this.$swal({
          icon: "warning",
          title: "Oops...",
          text: "Debes seleccionar una fecha",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }

      var data = {
        origin: 2,
        initDate:
          this.infoAccount.yearFrom +
          "-" +
          this.infoAccount.monthFrom +
          "-" +
          this.infoAccount.dayFrom,
        finDate:
          this.infoAccount.yearUntil +
          "-" +
          this.infoAccount.monthUntil +
          "-" +
          this.infoAccount.dayUntil,
      };
      this.loading.listA = true;
      axios
        .post("api/statement/account", data)
        .then((res) => {
          this.loading.listA = false;
          // console.log(res);
          if (res.data.cod == 0) {
            $("#account-state-get").modal("show");
            $("#account-state").modal("hide");
            this.listAccount = res.data.data;
          }
        })
        .catch((error) => {
          this.closeModal();
          this.loading.listA = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    closeModal() {
      $("#account-state-get").modal("hide");
    },
    downloadAccount() {
      if (
        this.infoAccount.monthFrom == null &&
        this.infoAccount.yearFrom == null &&
        this.infoAccount.dayFrom == null &&
        this.infoAccount.yearUntil == null &&
        this.infoAccount.monthUntil == null &&
        this.infoAccount.dayUntilFrom == null
      ) {
        this.$swal({
          icon: "warning",
          title: "Oops...",
          text: "Debes seleccionar una fecha",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }
      var data = {
        initDate:
          this.infoAccount.yearFrom +
          "-" +
          this.infoAccount.monthFrom +
          "-" +
          this.infoAccount.dayFrom,
        finDate:
          this.infoAccount.yearUntil +
          "-" +
          this.infoAccount.monthUntil +
          "-" +
          this.infoAccount.dayUntil,
        origin: 2,
      };
      this.loading.btn = true;

      this.$swal({
        confirmButtonColor: "#dc3545",
        icon: "info",
        title: "Info",
        text: "La descarga se esta iniciando, por favor espere un momento",
      });

      axios
        .post("api/download", data, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          this.loading.btn = false;
          const file = new Blob([res.data], {
            type: "application/pdf;charset=utf-8;",
          });
          const fileURL = URL.createObjectURL(file);
          // console.log(fileURL);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download =
            "reporte-generado-" +
            new Date().toISOString().substr(0, 10) +
            ".pdf";
          link.click();
          this.disableLoading = false;
        })
        .catch((error) => {
          // console.log(error.response.status);
          this.loading.btn = false;
          var sms = "Hubo un error al descargar el archivo, contacte con el administrador ";
          if (error.response.status == 400) {
            sms = "Las fechas enviadas son inválidas ";
          }
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: sms,
          });
        });
    },
    addCode() {
      if (this.validateCode1()) {
        var data = {
          code: this.code1,
          codePromotional: this.codePromotional,
        };
        this.disableLoading = true;
        axios
          .post("api/code/addPoint/lubricator", data)
          .then((res) => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.code1 = null;
              this.sendEvent();
            } else if (res.data.cod == 1) {
              app.$swal({
                icon: "warning",
                title: "Oops...",
                confirmButtonColor: "#dc3545",
                text: res.data.message,
              });
            }
            this.getDataUser();
            this.disableLoading = false;
          })
          .catch((error) => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
            this.disableLoading = false;
          });
      }
    },
    openRanking(value) {
      switch (value) {
        case 1:
          this.ranking = true;
          this.classRanking = false;
          this.classCaps = false;
          this.classRankingZ = true;
          this.rankinForZone = true;
          this.getRanking(1);
          break;
        case 2:
          this.ranking = true;
          this.classRanking = true;
          this.classCaps = false;
          this.classRankingZ = false;
          this.rankinForZone = false;
          this.getRanking(2);
          break;
        default:
          this.ranking = false;
          this.classCaps = true;
          this.classRanking = false;
          this.classRankingZ = false;
          break;
      }
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    dataInfo(data) {
      this.info = data;
      this.amount = data.amount;
    },
    editar() {
      if (this.validateAmount()) {
        var data = {
          amount: this.amount,
          id: this.info.id,
        };
        if (this.info.amount == this.amount) {
          this.errors.amount =
            "La cantidad de tapas debe ser diferente a la que tiene actualmente.";
          // console.log("La cantidad es la misma");
          return false;
        } else {
          this.errors.amount = false;
        }
        this.loading.btn = true;
        axios
          .put("api/lubricator/updateCaps", data)
          .then((res) => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              $("#exampleModal-edit").modal("hide");
              this.getHistory();
            }
            this.loading.btn = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.btn = false;
          });
      }
    },
    openShopping() {
      if (this.shopping) {
        this.shopping = false;
      } else {
        this.shopping = true;
        this.history = false;
        this.showLicense = false;
      }
      this.getShipping();
    },
    openHistory() {
      if (this.history) {
        this.history = true;
      } else {
        this.history = true;
        this.shopping = false;
        this.showLicense = false;
      }
      this.getHistory();
    },
    openLicense(){
      if(this.shopping){
        this.shopping = false;
      }
      if(this.history){
        this.history = false;
      }
      this.showLicense = true;
    },
    downloadPDF() {
      this.loading.btn = true;
      const element = document.getElementById('user_data_carnet');

      const options = {
        scale: 4,
        scrollY: 0,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight
      };

      html2canvas(element, options).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdfWidth = canvas.width * 0.75; // Usamos el ancho del lienzo del canvas para establecer el ancho del PDF
        const pdfHeight = canvas.height * 0.75; // Usamos el alto del lienzo del canvas para establecer el alto del PDF

        const pdf = new jsPDF('p', 'pt', [pdfWidth, pdfHeight]); // Creamos el objeto jsPDF con las dimensiones adecuadas

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight, '', 'FAST');
        pdf.save(`Carnet_Lubricador_${this.dataUser.name}.pdf`);
        this.loading.btn = false;
      });
    },
    getHistory() {
      this.loading.list = true;
      axios
        .get("api/lubricator/listCaps")
        .then((res) => {
          if (res.data.cod == 0) {
            this.loading.list = false;
            // var cont = 1;
            // console.log(res.data.data[0].caps);
            if (res.data.data[0].caps.length == 0) {
              this.alert.status = true;
              this.alert.message = "No se encontraron tapas redimidas.";
              return false;
            } else {
              this.alert.status = false;
              this.alert.message = "";
              this.listHistory = res.data.data[0].caps;
              for (let i = 0; i < this.listHistory; i++) {
                if (this.listHistory[i].lub_histories.length == 0) {
                  this.listHistory[i].dateCommercial = "Pendiente";
                } else {
                  this.listHistory[i].dateCommercial = this.listHistory[i].lub_histories;
                }
              }
            }
          }
        })
        .catch((error) => {
          this.loading.list = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    openModalDetails(data) {
      if (data.product_type_id == 4) {
        $("#loadingModal").modal("show");
        axios
          .get("superAdmin/commerce/won/get/bonusDetail/" + data.bonus_id)
          .then((res) => {
            $("#loadingModal").modal("hide");
            $("#exampleModalDetailsM").modal("show");
            // console.log(data);
            this.purchaseData = data;
            if (res.data.data) {
              this.purchaseData.day_of_activation =
                res.data.data.data.day_of_activation;
              this.purchaseData.expiration_date =
                res.data.data.data.expiration_date;
              this.purchaseData.code = res.data.data.data.code;
              // console.log(res.data.data);
            }
          })
          .catch((error) => {
            $("#loadingModal").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      } else if (data.product_type_id == 6) {
        $("#exampleModalDetailsM").modal("show");
        this.loading.descriptionAll = true;
        axios
          .get("api/product/zwapp/" + data.zwappId)
          .then((res) => {
            this.loading.descriptionAll = false;
            if (res.data.cod == 0) {
              if (data.bonus_id != null) {
                if (data.bonus_id.length >= 4) {
                  var validate =
                    data.bonus_id[0] +
                    data.bonus_id[1] +
                    data.bonus_id[2] +
                    data.bonus_id[3]; // se mantiene quemado porque siempre van a estar estas posiciones
                  if (validate == "http") {
                    data.showBtn = true;
                  }
                }
              }
              this.purchaseData = data;
              this.purchaseData.descrip = res.data.data.description;
            }
          })
          .catch(() => {
            this.purchaseData = data;
            this.loading.descriptionAll = false;
          });
      } else {
        $("#exampleModalDetailsM").modal("show");
        // console.log(data);
        this.purchaseData = data;
      }
    },
    downloadVoucher() {
      var a = document.createElement("a");
      a.download = true;
      a.target = "_blank";
      a.href = this.purchaseData.products.img;
      a.click();
    },
    getShipping() {
      this.listShopping = [];
      axios
        .get("superAdmin/commerce/shoppingHistory")
        .then((res) => {
          // console.log(JSON.stringify(res.data));
          if (res.data.cod == 0) {
            var list = res.data.data;
            // this.listShopping = res.data.data;
            if (list.length == 0) {
              this.alert.status = true;
              this.alert.message = "No se encontraron compras.";
            } else {
              for (let i = 0; i < list.length; i++) {
                // console.log(list[i])
                for (let j = 0; j < list[i].order_products.length; j++) {
                  // console.log(list[i].order_products[j])
                  var data = {
                    bonus_id: list[i].order_products[j].bonus_id,
                    description: list[i].order_products[j].product.description,
                    img: list[i].order_products[j].product.img,
                    name: list[i].order_products[j].product.name,
                    points: list[i].order_products[j].product.points,
                    product_type_id:
                      list[i].order_products[j].product.product_type_id,
                    product_id: list[i].order_products[j].product_id,
                    statusDes: list[i].order_products[j].status.name,
                    created_at: list[i].order_products[j].created_at,
                    price: list[i].order_products[j].product.price,
                    zwappId: list[i].order_products[j].id_won,
                  };
                  this.listShopping.push(data);
                }
              }
              this.alert.status = false;
              this.alert.message = "";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changePassword() {
      var app = this;
      if (this.validateForm()) {
        this.disableLoadingSend = true;
        this.form.email = this.dataUser.email;
        this.form.check = 1;
        axios
          .post("api/changePassword", this.form)
          .then(function(res) {
            if (res.data.ResponseCode == 0) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.ResponseMessage,
              });
              app.disableLoadingSend = false;
            } else if (res.data.ResponseCode == 1) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
              });
              app.disableLoadingSend = false;
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
              });
              app.disableLoadingSend = false;
            }
            $("#exampleModalPassword").modal("hide");
          })
          .catch(function(err) {
            console.log(err);
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: "Hubo un error en el sistema, intente nuevamente",
            });
            app.disableLoadingSend = false;
          });
      }
    },
    addCaps() {
      if (this.validateCode1()) {
        this.disableLoading = true;
        var app = this;
        var data = {
          amount: this.code1,
        };
        axios
          .post("api//addCaps", data)
          .then(function(res) {
            if (res.data.cod == 0) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.message,
              });
            }
            app.disableLoading = false;
            app.code1 = null;
            setTimeout(() => (app.errors.code1 = false), 10);
            app.openHistory();
          })
          .catch(function() {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text:
                "Hubo un error, intente en un momento o contáctese con el administrador",
            });
            app.disableLoading = false;
          });
      }
    },
    getDataUser() {
      var app = this;
      this.loading.profile = true;
      axios
        .get("api/showUser")
        .then(function(res) {
          app.loading.profile = false;
          app.dataUser = res.data.User;
          app.documentUser = res.data.User.document_type.name;
          app.cityUser = res.data.User.city.name;
          app.redeemCodes = res.data.Codes;
          app.points = parseInt(res.data.Points);
          app.caps = res.data.User.event_points;
          if(res.data.DistributorInfo){
            app.nameDistributor = res.data.DistributorInfo.name;
            app.infoDistributor = res.data.DistributorInfo.name + " " + res.data.DistributorInfo.last_name;
          }
          app.getExpiredPoints(app.dataUser.id);
          if(
              app.dataUser.name == "" || app.dataUser.name == null || 
              app.dataUser.last_name == "" || app.dataUser.last_name == null || 
              app.dataUser.address == "" || app.dataUser.address == null || 
              app.dataUser.phone == "" || app.dataUser.phone == null || 
              app.dataUser.email == "" || app.dataUser.email == null || 
              app.dataUser.birthdate == "" || app.dataUser.birthdate == null
            ){
              $('#exampleModalUpdate').modal({backdrop: 'static', keyboard: false});
              $('.close_update, .btn_cancel').css("display", "none");
          }
        })
        .catch(function(error) {
          console.log(error);
          app.loading.profile = false;
        });
    },
    getExpiredPoints(idUser){
      axios
      .post("superAdmin/expired/points/" + idUser)
      .then((response) => {
        if(response.data.cod == 0){
          this.expired_points = response.data.data.pointsLub;
        } else {
          this.$swal({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
          confirmButtonColor: "#dc3545",
        });
        }
      })
      .catch((error) => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
          confirmButtonColor: "#dc3545",
        });
      });
    },
    validateForm() {
      if (!this.form.pass) {
        this.errors.pass = "La contraseña es requerida.";
      }
      if (!this.form.pass_confirmation) {
        this.errors.pass_confirmation = "Lacontraseña es requerida.";
      }
      if (this.form.pass_confirmation != this.form.pass) {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
      if (
        !this.errors.pass &&
        !this.errors.pass_confirmation &&
        !this.validPassword(this.errors.pass)
      ) {
        return true;
      }
      return false;
    },
    validateCode1() {
      if (!this.code1) {
        this.errors.code1 = "El código es obligatorio.";
        if (this.isNumeric(this.code1) && this.code1 < 0) {
          this.errors.code1 = "El código es obligatorio.";
        }
      }
      if (!this.errors.code1) {
        return true;
      }
      return false;
    },
    validateAmount() {
      if (!this.amount) {
        this.errors.amount = "El número de tapas es requerido";
        if (this.isNumeric(this.amount) && this.amount < 0) {
          this.errors.amount = "El número de tapas no puede ser negativo";
        }
      }
      if (!this.errors.amount) {
        return true;
      }
      return false;
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    getRanking(value) {
      var cont = 1;
      var url = "";
      if (value == 1) {
        url = "api/ranking/distributor";
      } else {
        url = "api/ranking/global";
      }
      axios
        .get(url)
        .then((res) => {
          // console.log(res.data);
          if (res.data.cod == 0) {
            for (let i = 0; i < res.data.data.ranking.length; i++) {
              // console.log("**********");
              res.data.data.ranking[i].num = cont++;
              // console.log(res.data.data.ranking[i].num);
            }

            this.listRanking = res.data.data.ranking;
            this.totalLubricator = res.data.data.total;
          }
        })
        .catch((error) => {
          console.log('error: ', error);
        });
    },
    getRankingZ() {
      this.listRanking = [];
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listStates = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getGenders() {
      axios
        .get("api/getGenders")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listGenders = res.data.data;
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    deshabilitaRetroceso(){
      window.location.hash="no-back-button";
      window.location.hash="Again-No-back-button" //chrome
      window.onhashchange = function(){
        window.location.hash="";
      }
    },
    validateUpdate() {
      if(this.dataUser.name == "" || this.dataUser.name == null){
        this.errorUpdate.name = "El nombre es obligatorio";
        return false;
      }
      if(this.dataUser.last_name == "" || this.dataUser.last_name == null){
        this.errorUpdate.last_name = "El apellido es obligatorio";
        return false;
      }
      if(this.dataUser.state_id == "" || this.dataUser.state_id == null){
        this.errorUpdate.state_id = "El departamento es obligatorio";
        return false;
      }
      if(this.dataUser.city_id == "" || this.dataUser.city_id == null){
        this.errorUpdate.city_id = "La ciudad es obligatoria";
        return false;
      }
      if(this.dataUser.address == "" || this.dataUser.address == null){
        this.errorUpdate.address = "La dirección es obligatoria";
        return false;
      }
      if(this.dataUser.phone == "" || this.dataUser.phone == null){
        this.errorUpdate.phone = "El número de contacto es obligatorio";
        return false;
      }
      // if(this.dataUser.gender_id == 4){
      //   this.errorUpdate.gender_id = "El genero es obligatorio";
      //   return false;
      // }
      if(this.dataUser.email == "" || this.dataUser.email == null){
        this.errorUpdate.email = "El email es obligatorio";
        return false;
      }
      if(this.dataUser.birthdate == "" || this.dataUser.birthdate == null){
        this.errorUpdate.birthdate = "La fecha de nacimiento es obligatoria";
        return false;
      }
      if(
        !this.errorUpdate.name &&
        !this.errorUpdate.last_name &&
        !this.errorUpdate.state_id &&
        !this.errorUpdate.city_id &&
        !this.errorUpdate.address &&
        !this.errorUpdate.phone &&
        // !this.errorUpdate.gender_id &&
        !this.errorUpdate.email &&
        !this.errorUpdate.birthdate
      ){
        return true;
      }
    },
    updateData() {
      if(this.validateUpdate()){
        var data = {
          documentType: this.dataUser.document_type_id,
          documentNumber: this.dataUser.document_number,
          name: this.dataUser.name,
          lastName: this.dataUser.last_name,
          stateId: this.dataUser.state_id,
          cityId: this.dataUser.city_id,
          address: this.dataUser.address,
          phone: this.dataUser.phone,
          genderId: this.dataUser.gender_id,
          email: this.dataUser.email,
          birthdate: this.dataUser.birthdate
        };
        this.disableLoadingSend = true;
        axios
          .put("api/update", data)
          .then((res) => {
            if (res.data.cod == 0) {
              $("#exampleModalUpdate").modal("hide");
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.disableLoadingSend = false;
              this.getDataUser();
            }
          })
          .catch((error) => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
            this.disableLoadingSend = false;
          });
      }
    },
    showPass(type){
      if(type == 1){
        let pass = this.$refs.current_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass1').addClass('fa-eye');
          $('#pass1').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass1').addClass('fa-eye-slash');
          $('#pass1').removeClass('fa-eye');
        }
      } 
      else if(type == 2){
        let pass = this.$refs.password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass2').addClass('fa-eye');
          $('#pass2').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass2').addClass('fa-eye-slash');
          $('#pass2').removeClass('fa-eye');
        }
      } else {
        let pass = this.$refs.confirm_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass3').addClass('fa-eye');
          $('#pass3').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass3').addClass('fa-eye-slash');
          $('#pass3').removeClass('fa-eye');
        }
      }
    },
    // getIp(){
    //   axios
    //   .get("https://ipinfo.io/json")
    //   .then((res) => {
    //     if(res.status == 200){
    //       this.ip_address = res.data.ip;
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // },
    sendEvent(){
      axios
      .post("api/send-data-event", {
        event_name: "Inscripción de códigos Lubricadores",
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: document.URL,
        action_source: "website",
        user_data: {
          client_ip_address: this.ip_address,
          client_user_agent: window.navigator.userAgent
        }
      })
      .then(() => {
        console.log("Evento enviado correctamente.");
      })
      .catch((err) => {
        console.log("Error enviando el evento:", err);
      });
    },
  },
  mounted() {
    this.getRanking(1);
    // this.getHistory();
    this.getDataUser();
    this.getTypeDocuments();
    this.getListStates();
    this.getGenders();
    this.deshabilitaRetroceso();
    // this.getIp();
  },
};
</script>

<style scoped>
.th-account-1 {
  background-color: #d82112;
  color: #fff;
}
.th-account {
  background-color: #f32918;
  color: #fff;
}
.table-account-t td:nth-child(1) {
  background-color: #e7e7e7;
}
.table-account-t td:nth-child(3) {
  background-color: #e7e7e7;
}
.table-account-t td:nth-child(5) {
  background-color: #e7e7e7;
}
.table-account {
  padding: 6px;
  background-color: #fff;
  height: 300px;
  overflow: auto;
}
.btn-get-black {
  background-color: #000;
  color: #fff;
  margin-top: 110px;
}
.btn-down-yellow {
  border-radius: 30px;
  background-color: #fdd200;
  color: #d82233;
  font-weight: bold;
  padding: 4px 50px 4px 50px;
}
.btn-down-yellow:hover {
  color: "#ffffff" !important;
}
.div-account {
  margin: 0px;
  padding: 3px 0px 3px 0px;
  background-color: #fff;
  width: 100%;
}
.img-account {
  border-radius: 22px;
  background-position: center;
  background-image: url("./../../assets/img/infoLubricador.jpg");
}
.info-promo-l {
  text-align: left;
  font-size: small;
  padding-bottom: 0px;
  margin-bottom: 5px;
}
body {
  padding-right: 0px !important;
  /* line-height: 0; */
}
.div-date {
  display: none;
}
table td:nth-child(4) {
  width: 10px !important;
}
.btn-transparent {
  color: #fff;
  font-weight: bold;
  font-size: 15px;
}
.btn-transparent.active {
  background-color: #fff !important;
  color: #dc3545;
  font-weight: bold;
  font-size: 15px;
}
.btn-transparent:active {
  background-color: #fff !important;
  color: #dc3545;
  font-weight: bold;
  font-size: 15px;
}
.btn-transparent:hover {
  background-color: #fff !important;
  color: #dc3545;
  font-weight: bold;
  font-size: 15px;
}
.table-lubricator {
  border: 1px solid !important;
  border-color: #dee2e6 !important;
  background-color: #7d7d7d3d;
}
.td-lubricator {
  color: #fff;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #0000007a !important;
}
.lubricator-title-modal {
  color: #595959 !important;
}
.prod-card {
  width: 100px;
}
.table-h {
  border-radius: 5px;
}
.title-ranking {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
}
.table-light tbody + tbody,
.table-light td,
.table-light th,
.table-light thead th {
  border-color: #d8d8dc;
}
.subtitle-h {
  text-align: left;
  color: #dc3545;
  font-size: 28px;
  font-family: "GothamBoldItalic", sans-serif;
}
/* History codes */
#content-history-id {
  padding-top: 2%;
  padding-bottom: 2%;
}
.content-history {
  background-color: #eaeaea;
}
.btn-history {
  cursor: pointer;
}
.btn-history-s:hover {
  cursor: pointer;
  background-color: #0060c3;
}
.btn-history:hover {
  cursor: pointer;
  background-color: #d82233;
}
.title-caps {
  color: #fdcd00;
  font-size: 18px;
}
.th-title {
  color: #dc3545;
}
.th-title-r {
  color: #fff;
}
/* End history code */
.padding-title {
  padding-bottom: 12% !important;
}
.p-phone {
  padding-left: 8%;
}
.p-historial {
  /* border-bottom: 1px solid; */
  cursor: pointer;
  color: #ffffff;
}
.p-historial:hover {
  color: #dc3545;
  /* border-bottom: 0px solid; */
}
.text-profile {
  font-size: 13px;
}
.icon-img-svg-phone {
  width: 28px;
  height: 40px;
  margin-top: 13%;
  text-align: center;
  /* padding-left: 43px; */
}
.icon-img-svg {
  width: 45px;
  height: 30px;
  margin-top: 13%;
  float: right;
}
.icon-img-svg-name {
  width: 60px;
  height: 60px;
  /* margin-bottom: 30%; */
}
.label-title {
  font-size: 20px;
  margin-bottom: 0rem !important;
}
.title-profile-1 {
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left !important;
  font-size: 50px;
  font-display: swap;
}
.modal-title {
  color: white !important;
}
.button-send-code {
  border-radius: 5px !important;
  padding: 9px !important;
}
.text-points {
  padding-top: 4%;
  font-size: 65px;
  font-family: "GothamBoldItalic", sans-serif;
  margin-bottom: 0px;
}
.points {
  padding: 2%;
  margin-bottom: 7%;
  border: 1px solid;
  border-color: white;
  border-radius: 5px;
}
/* .img-caps{
    position: relative;
    top: 90px;
    margin: 0 30% 30% 30%;
    display: block;
  } */
.info-caps {
  padding: 5% 2% 0% 2%;
  margin-bottom: 7%;
  background-color: #fd0001;
  border-radius: 5px;
}
.title-profile {
  font-size: 18px;
  /* text-align: left !important; */
  color: white !important;
}
.title-profile-user {
  font-size: 13px !important;
}
.content-profile-user {
  padding-left: 5%;
  padding-top: 8%;
  padding-bottom: 5%;
  height: 100%;
}
.input-reset {
  background-color: #ffffff00 !important;
  border-radius: 10px !important;
  border-color: white !important;
  height: 30px !important;
  color: white !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.input-reset ::placeholder {
  color: white !important;
}
.icon::before {
  position: absolute;
  top: 20%;
  left: 5%;
}
.fa.iconreset {
  color: white;
}
#contentProfileUser {
  background-size: cover;
  background-image: url("../../assets/img/FOTO-4.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.input-code {
  background-color: #ffffff00 !important;
  border-radius: 5px !important;
  border-color: white !important;
  height: 40px !important;
  color: white !important;
  padding: 0.375rem 1.7rem !important;
  font-size: 13px !important;
}
.input-code::placeholder {
  color: white;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.modal-title {
  color: #595959 !important;
}
#content_title_carnet{
  margin: auto;
  display: flex;
}
.title_carnet {
  color: #dc3545;
  font-size: 28px;
  font-family: "GothamBoldItalic", sans-serif;
  margin: 30px;
}
#content_carnet{
  margin: auto;
}
#user_data_carnet{
  margin: auto;
  width: 530px;
  height: 768px;
  background-image: url('../../assets/imgsCarnet/background_carnet.jpg');
  background-position: center;
  background-size: cover;
}
.data_carnet{
  padding: 60% 0% 0% 0%;
}
.name_and_last_name{
  background-color:#838384; 
  border-radius:20px; 
  float:left; 
  padding:2px 50px 2px 50px; 
  margin:auto auto auto 15px;
}
.cc_and_document{
  width:100%; 
  text-align:left; 
  float:left; 
  padding:2px 20px 2px 50px; 
  margin:auto auto 15px 15px;
}
.user_role, .user_plate, .user_city{
  width:100%; 
  text-align:left; 
  float:left; 
  padding:2px 20px 2px 50px; 
  margin:auto auto auto 15px;
}
.user_activo{
  max-width: 80%;
  margin: auto;
  padding: 20px 0px 0px 0px;
}
.miembro_activo{
  font-size: 30px;
  text-align: center;
}
.havoline_motoclub{
  font-size: 18px;
  color: #ff1212;
}
.red_line{
  max-width: 55%;
  margin: auto;
  border-bottom: 3px solid #ff1212;
}
.qr_code{
  display: flex; 
  justify-content: center;
}
.info_adicional{
  max-width: 75%;
  margin: 10px auto auto auto;
  line-height: 13px;
}
#btn_download_carnet{
  width: 40%;
  margin: 25px auto 25px auto;
}
.modal-header .close {
  font-size: 40px;
  color: #dc3545;
}
#close_detail_product{
  padding: 10px;
  margin: -40px 0px 0px -25px;
  font-size: 40px;
  color: #dc3545;
}
.expired_points{
  padding: 2%;
  margin-bottom: 7%;
  border: 1px solid;
  border-color: white;
  border-radius: 5px;
}
.title_expired_points{
  font-size: 16px;
  font-family: "GothamBoldItalic", sans-serif;
}
.cant_expired_points{
  font-size: 25px;
  font-family: "GothamBoldItalic", sans-serif;
  margin: auto;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
  color: #dc3545;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .mtPass {
    margin-left: 36px;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .padding-sm-code {
    padding-top: 12%;
  }
  .content-profile-user {
    padding-top: 12%;
    padding-bottom: 10%;
  }
  .p-phone {
    padding-left: 3%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-phone {
    padding-left: 0% !important;
  }
  .content-profile-user {
    padding-top: 22%;
    padding-bottom: 20%;
  }
  .padding-sm-code {
    padding-top: 22%;
  }
  .label-title-sm {
    font-size: 13px;
  }
  .icon-img-svg-name {
    width: 38px;
    height: 35px;
    float: left;
    /* margin-bottom: 30%; */
  }
  .padding-sm2 {
    padding-left: 0px;
  }
  .table-date {
    display: none;
  }
  .div-date {
    display: inline;
  }
  .title_carnet {
    font-size: 20px;
  }
  #content_carnet{
    margin: auto;
  }
  #user_data_carnet{
    margin: auto;
    width: 98%;
    height: 600px;
    background-image: url('../../assets/imgsCarnet/background_carnet.jpg');
    background-position: center;
    background-size: cover;
  }
  .data_carnet{
    padding: 59% 0% 0% 0%;
  }
  .data_carnet span, b{
    font-size: 10px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .data_carnet b{
    padding: 0px !important;
  }
  .name_and_last_name{
    padding:2px 20px 2px 20px; 
  }
  .cc_and_document{
    padding:2px 20px 2px 20px; 
  }
  .user_role, .user_plate, .user_city{
    padding:0px 20px 0px 20px !important;
  }
  .user_activo{
    max-width: 80%;
    margin: auto;
    padding: 20px 0px 0px 0px;
  }
  .miembro_activo{
    font-size: 22px;
    text-align: center;
  }
  .havoline_motoclub{
    font-size: 12px !important;
    color: #ff1212;
  }
  .red_line{
    max-width: 55%;
    margin: auto;
    border-bottom: 3px solid #ff1212;
  }
  .qr_code div canvas, .qr_code div img{
    max-width: 100px !important;
  }
  .info_adicional{
    max-width: 75%;
    margin: 10px auto auto auto;
    line-height: 13px;
    font-size: 9px !important;
  }
  #btn_download_carnet{
    width: 60%;
    margin: 25px auto 25px auto;
  }
  .card-body > p > b {
    font-size: 14px !important;
  }
  .btn-outline-danger {
    font-size: 12px !important;
  }
  #exampleModalDetailsMLabel > b{
    font-size: 25px !important;
  }
  .subtitle-h{
    font-size: 22px;
  }
}

@media (max-width: 420px) and (min-width: 390px) {
  .data_carnet{
    padding: 58% 0%;
  }
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>
